import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { NgxAuthService } from '../services/ngx-auth.service';
import { AUTH_CONFIG, NgxAuthConfig } from '../interfaces/auth-config.interface';

export const AuthUserGuard: CanActivateFn = (_route, state) => {
  const authService = inject(NgxAuthService);
  const router = inject(Router);
  const config = inject<NgxAuthConfig>(AUTH_CONFIG);

  return authService.state.pipe(
    take(1),
    map((user) => {
      if (user) {
        return true;
      }

      const returnUrl = state.url || config.homeUrl;
      void router.navigate([config.noAuthRedirectUrl], {
        queryParams: { returnUrl },
      });

      return false;
    }),
  );
};

